/*
  Mirage — capture the Swym wishlist at Booxi booking time.

  Booxi's app embed defines window.booxiApp.addProduct(booking) and calls it
  from exactly two places: the modal's onClose, and getEncodedBooking() on the
  redirect path. Which of the two is live is a Booxi back-office setting, not
  our code, so both are covered here.

  This script never blocks, delays or alters Booxi's own behaviour. A booking
  that fails to add its product to the cart costs the salon money; a wishlist
  that fails to send costs nothing.
*/
(function () {
  var ENDPOINT = 'https://lhg-mirage-preorder-worker.vlad-a.workers.dev/booxi/wishlist';
  var STATE_KEY = 'mirage:wishlist-state';
  var BOOKING_ID_RE = /^[ARL]\d{8}$/;
  var sent = {};

  /*
    Returns an array of product ids, or null for "we do not know".
    The distinction matters: the worker replaces the whole metafield, so an
    empty array CLEARS the customer's wishlist. A first visit, a private
    window, or a page where mirage-wishlist.js never ran must therefore send
    nothing at all rather than an empty list. (mirage-wishlist.js:42 reads a
    missing key as []; that is right for painting hearts and wrong here.)
  */
  function readSnapshot() {
    var raw;
    try {
      raw = localStorage.getItem(STATE_KEY);
    } catch (e) {
      return null; // private mode: storage throws on access
    }
    if (raw === null) return null;

    var parsed;
    try {
      parsed = JSON.parse(raw);
    } catch (e) {
      return null;
    }
    if (!Array.isArray(parsed)) return null;

    var ids = [];
    for (var i = 0; i < parsed.length; i++) {
      var pair = parsed[i];
      if (!Array.isArray(pair) || pair.length === 0) continue;
      var empi = String(pair[0]);
      if (!/^\d+$/.test(empi)) continue;
      ids.push(empi);
    }

    /*
      Every stored entry must parse, or we know nothing -- a partial read is
      not a smaller wishlist, it is an unknown one. If even one entry is
      rejected, ids.length falls short of parsed.length and we return null
      here rather than the subset that did parse: sending that subset would
      have the worker replace her saved wishlist with a piece of itself, and
      nobody would see an error, she would just quietly lose the rest. An
      input that really was [] to begin with (parsed.length === 0) still
      correctly returns [] -- that is a genuinely empty wishlist, not a
      corrupted one.
    */
    if (ids.length !== parsed.length) return null;
    return ids;
  }

  function capture(booking) {
    try {
      if (!booking || typeof booking !== 'object') return;

      var bookingId = booking.bookingId;
      if (typeof bookingId !== 'string' || !BOOKING_ID_RE.test(bookingId)) return;
      if (sent[bookingId]) return;

      var client = booking.client || {};
      if (typeof client.email !== 'string' || client.email.indexOf('@') === -1) return;

      var products = readSnapshot();
      if (products === null) return;

      var body = JSON.stringify({
        v: 1,
        bookingId: bookingId,
        email: client.email,
        products: products
      });

      /*
        text/plain, not application/json. sendBeacon cannot perform a CORS
        preflight, and application/json is not a safelisted content type — the
        browser would drop the request before it left the page, silently, in
        production only.
      */
      /*
        Only mark it sent if the browser actually took it. sendBeacon returns
        false when the keepalive queue is full; marking first would suppress
        the wrapper/query-parser double coverage that exists precisely to
        catch a miss.
      */
      if (navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain' }))) {
        sent[bookingId] = true;
      }
    } catch (e) {
      /* capture must never affect the booking flow */
    }
  }

  function wrapAddProduct() {
    var app = window.booxiApp;
    if (!app || typeof app.addProduct !== 'function' || app.__mrgWishlistWrapped) return false;

    var original = app.addProduct;
    app.addProduct = function (booking) {
      // Original first, synchronously, before anything of ours can throw or
      // delay. capture() runs in finally so it also fires if Booxi throws.
      try {
        return original.apply(this, arguments);
      } finally {
        capture(booking);
      }
    };

    /*
      Confirm the assignment actually stuck before declaring victory. If
      addProduct is ever a non-writable property, the assignment above
      silently no-ops in sloppy mode -- app.addProduct still === original,
      nothing throws, and a flag saying "wrapped" would stop the polling
      loop for good with the wrapper never actually installed. Reporting
      false here lets the bounded loop (40 tries) keep trying instead.
    */
    if (app.addProduct === original) return false;

    app.__mrgWishlistWrapped = true;
    return true;
  }

  /*
    The redirect path decodes ?booking= inside booxiApp.init(), which runs
    synchronously at the end of the app embed script. A wrapper installed
    later never sees that call, so parse the parameter ourselves. Doing both
    is not redundant — it is what makes load order irrelevant. The `sent`
    guard keeps the double coverage from double sending.
  */
  function captureFromQuery() {
    try {
      var encoded = new URLSearchParams(window.location.search).get('booking');
      if (!encoded) return;
      var decoded = decodeURIComponent(
        atob(encoded)
          .split('')
          .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join('')
      );
      capture(JSON.parse(decoded));
    } catch (e) {
      /* not our booking parameter */
    }
  }

  captureFromQuery();

  if (!wrapAddProduct()) {
    // The app embed may not have run yet. Ten seconds is far longer than it
    // takes and far shorter than any booking.
    var tries = 0;
    var timer = setInterval(function () {
      if (wrapAddProduct() || ++tries >= 40) clearInterval(timer);
    }, 250);
  }
})();
